export default __webpack_public_path__ + "static/media/yuki.a82eac3f.png";